(function($){

    //SINGLE prodotto

    $(document).on( 'click', '.accordion-body .section-title', function() {

        if($(this).parent().parent().find('.collapse').hasClass('open')){
            $(this).find('.accordion').addClass('close');
            $(this).parent().parent().find('.collapse').removeClass('open');
        } else {
            $(this).find('.accordion').removeClass('close');
            $(this).parent().parent().find('.collapse').addClass('open');
        }

    });

})
(jQuery);
